module.exports = __webpack_public_path__ + "img/23ccf76.png";